<template>
  <DashboardLayout :breadcrumbs="breadcrumbs" :hierarchy-params="{assignment: $route.params.documentId}">
    <div class="container is-fluid">
      <div class="level mo">
        <div class="level-left">
          <div class="control mr-10">
            <h1 class="title is-5">{{ detail.name }}</h1>
          </div>
          <div class="control mr-10" v-if="detail.state === 'draft' && isAuthor">
            <a class="edit" @click="edit">
              <b-icon icon="pencil" size="is-small" class="icon"></b-icon>
              {{ $t('interface.edit') }}
            </a>
          </div>
          <div class="control mr-10" v-if="canChangeState">
            <button class="button is-success is-small" @click="nextState">
              <span v-if="detail.state === 'draft'">{{ $t('interface.publish') }}</span>
              <span v-if="detail.state === 'new'">{{ $t('interface.startExecution') }}</span>
              <span v-if="detail.state === 'in_process'">{{ $t('interface.endExecution') }}</span>
              <span v-if="detail.state === 'done'">{{ $t('interface.accept') }}</span>
            </button>
          </div>
          <div class="control mr-10" v-if="detail.state === 'done' && (isAuthor || isDocflowSupervisor)">
            <button class="button is-danger is-small" @click="reject">
              <span>{{ $t('interface.reject') }}</span>
            </button>
          </div>
          <div class="control"
               v-if="!['closed', 'cancelled', 'done'].includes(detail.state)
               && (isAuthor || isDocflowSupervisor) && !detail.is_auto_generated">
            <button class="button is-danger is-small" @click="cancel">
              <span v-if="detail.state === 'draft'">{{ $t('documents.removeDocument') }}</span>
              <span v-else>{{ $t('documents.rejectDocument') }}</span>
            </button>
          </div>
        </div>
      </div>
      <b-tabs @change="tabChange">
        <b-tab-item :label="$t('interface.information')">
          <DocumentInformation></DocumentInformation>
        </b-tab-item>
        <b-tab-item :label="$t('documents.tasks')">
          <Tasks></Tasks>
        </b-tab-item>
      </b-tabs>
    </div>
    <NotePrompt ref="notePrompt"/>
  </DashboardLayout>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  import DashboardLayout from '@/components/DashboardLayout'
  import DocumentInformation from '@/components/DocumentInformation'
  import Tasks from '@/components/Tasks'
  import NotePrompt from '@/components/NotePrompt'

  export default {
    components: {
      DashboardLayout,
      DocumentInformation,
      Tasks,
      NotePrompt
    },
    methods: {
      edit() {
        this.$router.push({
          name: 'editDocument',
          params: {documentId: this.detail.id}
        })
      },
      reject() {
        this.$refs.notePrompt.open({
          onConfirm: note => this.$store.dispatch('Document/reject', note).then(this.loadDocument)
        })
      },
      nextState() {
        this.$store.dispatch('Document/nextState', null).then(() => {
          this.$store.dispatch('Document/getDetail', this.$route.params.documentId)
        })
      },
      tabChange(i) {
        if (i === 1) {
          this.$store.dispatch('Task/list', {documentId: this.$route.params.documentId, q: ''})
        }
      },
      cancel() {
        this.$dialog.confirm({
          title: this.$t('documents.rejectDocument'),
          message: this.$t('documents.rejectSubmition'),
          confirmText: this.$t('documents.rejectDocument'),
          cancelText: this.$t('interface.cancel'),
          type: 'is-danger',
          hasIcon: true,
          onConfirm: () => {
            if (this.detail.state === 'draft') {
              this.$store.dispatch('Document/cancel', null).then(() => this.$router.push({name: 'documents'}))
            } else {
              this.$refs.notePrompt.open({
                onConfirm: note => this.$store.dispatch('Document/cancel', note).then(this.loadDocument)
              })
            }
          }
        })
      },
      loadDocument() {
        this.$store.dispatch('Document/getDetail', this.$route.params.documentId)
      }
    },
    mounted() {
      this.loadDocument()
    },
    computed: {
      ...mapState('Document', ['detail']),
      ...mapState('Account', ['account']),
      ...mapGetters('Account', ['isDocflowController', 'isDocflowSupervisor', 'isSuperUser']),
      isEditable() {
        return this.detail.state === 'new' && (this.isMaintainer || this.isAuthor)
      },
      isAuthor() {
        return (this.detail.author && this.detail.author.id === this.account.employee.id) || this.isSuperUser
      },
      isMaintainer() {
        return (this.detail.maintainer && this.detail.maintainer === this.account.employee.id) || this.isSuperUser
      },
      canChangeState() {
        return (['new', 'in_process'].includes(this.detail.state) && (this.isMaintainer || this.isDocflowController)
          && !this.detail.is_auto_generated)
          || (this.detail.state === 'draft' && (this.isAuthor || this.isMaintainer))
          || (this.detail.state === 'done' && this.isAuthor)
      },
      breadcrumbs() {
        return [
          {name: 'documents', path: 'documents'},
          {name: 'documentDetail'}
        ]
      }
    }
  }
</script>

<style lang="scss" scoped>

  .dialog {
    .input {
      resize: vertical;
      min-height: 80px;
    }
  }
</style>
